module.exports = __webpack_public_path__ + "img/image24.2bb9c03f.png";